export const topCatData = [
    {
      name: "Rice / चावल",
      link: "/nano-category/rice",
      image: "rice.jpg",
    },
    {
      name: "Flour / आटा",
      link: "/nano-category/flour",
      image: "flour.jpg",
    },
    {
      name: "Pulse's / दाल",
      link: "/nano-category/pulse",
      image: "pulse.jpg",
    },
    {
      name: "Cooking Oil",
      link: "/nano-category/oil",
      image: "cooking-oil.jpg",
    },
    {
      name: "Covid Essential",
      link: "/nano-category/handwash-and-sanitizers",
      image: "handwash-and-sanitizer.jpg",
    },
    {
      name: "Kurkure and Chips",
      link: "/nano-category/kurkure-and-chips",
      image: "chips.jpg",
    },
    {
      name: "Biscuits",
      link: "/nano-category/biscuits",
      image: "biscuts.jpg",
    },
    {
      name: "Tea and Coffee",
      link: "/nano-category/tea-and-coffee",
      image: "tea-coffee.jpg",
    }
  ];
  
export default topCatData;